module.exports = __webpack_public_path__ + "static/media/TCC_logo.34a7943d.jpg";